import React, { useEffect, useState } from "react";
import api from "../../api";
import "bootstrap/dist/css/bootstrap.min.css";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../../utils/toastMessages";
import { formatDateToUserTimeZone } from "../../utils/formatDate";
// import { formatDateToUserTimeZone } from "../../utils/formatDate";
import axios from "axios";
import crossIcon from "../../assets/UserIcons/Cancel.svg";
import viewIcon from "../../assets/UserIcons/ViewIcon.svg";
import { useTableSort } from "../../hooks/useTableSort";
import { SortableHeader } from "../../components/SortableHeader";

const TrainingQA = ({ uploadedQuestions = [] }) => {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [questions, setQuestions] = useState(uploadedQuestions || []);
  const [isAdding, setIsAdding] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const [showViewQAModal, setShowViewQAModal] = useState(false);
  const [viewQuestion, setViewQuestion] = useState("");
  const [viewAnswer, setViewAnswer] = useState("");

  const detectQAType = (question = "") => {
    const q = question.toLowerCase();

    if (/(list|steps|types of|examples)/.test(q)) return "List-based Q&A";
    if (/(do you think|should|is it good|opinion)/.test(q))
      return "Opinion Q&A";
    if (/(can you|could you|please|tell me)/.test(q))
      return "Conversational Q&A";
    if (/(also|what about|further|and then)/.test(q)) return "Follow-up Q&A";
    if (/(what is|how to|define|explain)/.test(q)) return "Documentation Q&A";

    return "Other";
  };

  const countWords = (text = "") =>
    text.trim() ? text.trim().split(/\s+/).length : 0;

  const [summary, setSummary] = useState({
    totalCharacters: 0,
    limit: 0,
    completion: 0,
  });

  const limit = 100000;

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  useEffect(() => {
    if (!questions.length) return;

    let totalChars = 0;
    let totalWords = 0;
    let active = 0;
    let inactive = 0;

    const typeStats = {
      "Documentation Q&A": { count: 0, chars: 0, words: 0 },
      "Conversational Q&A": { count: 0, chars: 0, words: 0 },
      "Opinion Q&A": { count: 0, chars: 0, words: 0 },
      "List-based Q&A": { count: 0, chars: 0, words: 0 },
      "Follow-up Q&A": { count: 0, chars: 0, words: 0 },
    };

    questions.forEach((q) => {
      // Status count (for display only)
      q.upload_status === "1" ? active++ : inactive++;

      // ❌ Ignore rejected/inactive in calculations
      if (q.upload_status !== "1") return;

      const text = `${q.question} ${q.answer}`;
      const chars = q.totalCharacters || text.length;
      const words = countWords(text);

      totalChars += chars;
      totalWords += words;

      const type = detectQAType(q.question);
      if (typeStats[type]) {
        typeStats[type].count += 1;
        typeStats[type].chars += chars;
        typeStats[type].words += words;
      }
    });

    // ✅ Decide limit AFTER accumulation
    const isLimitExceeded = totalChars > limit;
    const excessChars = isLimitExceeded ? totalChars - limit : 0;

    setSummary({
      totalCharacters: totalChars,
      totalWords,
      limit,
      completion: Math.min(Math.round((totalChars / limit) * 100), 100),
      isLimitExceeded,
      excessChars,
      totalQA: active + inactive,
      activeQA: active,
      inactiveQA: inactive,
      types: typeStats,
    });
  }, [questions, limit]);

  const handleAdd = async () => {
    if (!question.trim() || !answer.trim()) {
      showErrorToast(TOAST_MESSAGES.QA_UPLOAD.EMPTY);
      return;
    }

    setIsAdding(true); // ✅ moved after validation

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/upload/qa`,
        {
          question,
          answer,
          metadata: {
            submitted_by: "admin", // optional metadata
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      showSuccessToast(TOAST_MESSAGES.QA_UPLOAD.SUCCESS);

      const newEntry = {
        question,
        answer,
        totalCharacters: question.length + answer.length,
        updatedAt: new Date().toLocaleString(),
      };

      setQuestions([newEntry, ...questions]);
      setQuestion("");
      setAnswer("");
      fetchQAPairs();
    } catch (err) {
      console.error("Upload error:", err.response?.data || err.message);
      showErrorToast(TOAST_MESSAGES.QA_UPLOAD.ERROR);
    } finally {
      setIsAdding(false);
    }
  };

  const handleCancel = () => {
    setIsCancelling(true);

    setTimeout(() => {
      setQuestion("");
      setAnswer("");
      setIsCancelling(false);
    }, 500); // 2 second simulated delay for feedback
  };

  useEffect(() => {
    fetchQAPairs();
  }, []);

  const fetchQAPairs = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/uploaded-files/qa`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // Transform if needed
      const transformed = res.data.map((item) => ({
        question: item.question,
        upload_id: item.upload_id,
        upload_status: item.upload_status,
        answer: item.answer,
        totalCharacters: item.question.length + item.answer.length,
        updatedAt: item.updated_timestamp
          ? formatDateToUserTimeZone(item.updated_timestamp)
          : "",
      }));

      setQuestions(transformed);

      console.log(transformed, "hdjdfshjjdsf");
    } catch (err) {
      console.error("❌ Error fetching Q&A pairs:", err);
      showErrorToast("Failed to load uploaded Q&A pairs");
    }
  };

  const handleChangeQAStatus = async (uploadId, currentStatus) => {
    console.log(currentStatus);
    const newStatus = currentStatus == "1" ? "0" : "1";

    console.log(uploadId);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/uploaded-files/update_qa_status/${uploadId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ upload_status: newStatus }),
        },
      );

      const result = await response.json();

      if (!response.ok) {
        showErrorToast(result.message || "Failed to update status");
        return;
      }

      showSuccessToast("Status updated successfully");

      // Refresh your QA list
      fetchQAPairs();
    } catch (err) {
      console.error("Error updating status:", err);
      showErrorToast("Something went wrong");
    }
  };
  const { sortedData, requestSort, sortConfig } = useTableSort(questions);
  return (
    <div
      className="m-0 px-2 h-100"
    >
      <div className="row">
        {/* Q&A Form */}
        <div className="col-lg-8">
          <div className=" p-4 rounded border shadow-sm">
            <label className="form-label fw-semibold">Question</label>
            <div className="mb-3">
              <input
                className="form-control border-1 rounded"
                // style={{ backgroundColor: "#FAF9F9", borderColor: "#3e3e3e" }}
                value={question}
                placeholder="How are you?"
                onChange={(e) => setQuestion(e.target.value)}
                disabled={isAdding} // ✅ disable while adding
              />
            </div>
            <label className="form-label fw-semibold">Answer</label>
            <div className="mb-4">
              <textarea
                rows={3}
                className="input-textarea1 p-2 rounded"
                // style={{ backgroundColor: "#FAF9F9", borderColor: "#3e3e3e" }}
                value={answer}
                placeholder="Enter text..."
                onChange={(e) => setAnswer(e.target.value)}
                disabled={isAdding} // ✅ disable while adding
              />
            </div>
            <div className="d-flex gap-3">
              <button
                className="cancle-btn flex-fill border-1 fw-semibold w-50"
                // style={{ borderColor: "#3e3e3e" }}
                onClick={handleCancel}
                disabled={isCancelling}
              >
                {/* {isCancelling ? <>Cancelling...</> : "Cancel"} */}
                Cancel
              </button>
              <button
                className="custom-btn w-50 fw-semibold text-white"
                // style={{ backgroundColor: "#3e3e3e" }}
                onClick={handleAdd}
                disabled={isAdding}
              >
                {isAdding ? "Uploading..." : "Upload"}
              </button>
            </div>
          </div>

          {/* Table Section */}
          <div className="mt-4">
            <div
              className="table-responsive"
              style={{ maxHeight: "330px", overflowY: "auto" }}
            >
              <table className="table text-left trainingQA-table align-middle">
                <thead className="table-light">
                  <tr>
                    {/* <th>Sr.No.</th> */}
                    <SortableHeader
                      column="question"
                      label="Question"
                      sortConfig={sortConfig}
                      onSort={requestSort}
                    />
                    <SortableHeader
                      column="answer"
                      label="Answer"
                      sortConfig={sortConfig}
                      onSort={requestSort}
                    />
                    <SortableHeader
                      column="qa_length"
                      label="Total Characters"
                      sortConfig={sortConfig}
                      onSort={requestSort}
                    />
                    <SortableHeader
                      column="updatedAt"
                      label="Uploaded On"
                      sortConfig={sortConfig}
                      onSort={requestSort}
                    />
                    {/* <SortableHeader
                      column="upload_status"
                      label="Status"
                      sortConfig={sortConfig}
                      onSort={requestSort}
                    /> */}

                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedData.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="refresh-prompts ak-text-md">
                        No Q&A have been trained yet.
                      </td>
                    </tr>
                  ) : (
                    sortedData.map((q, index) => (
                      <tr key={index}>
                        {/* <td>{index + 1}</td> */}
                        <td
                          className="text-truncate"
                          style={{ maxWidth: "300px" }}
                          title={q.question}
                        >
                          {q.question}
                        </td>
                        <td
                          className="text-truncate"
                          style={{ maxWidth: "300px", paddingRight: "40px" }}
                          title={q.answer}
                        >
                          {q.answer}
                        </td>
                        <td>
                          {q.totalCharacters ||
                            q.question.length + q.answer.length}
                        </td>
                        <td>
                          {formatDateToUserTimeZone(q.updatedAt || new Date())}
                        </td>
                        {/* <td className="text-left">
                          <select
                            className={`badge ${
                              q.upload_status == "1"
                                ? "bg-success"
                                : "bg-danger"
                            }`}
                            value={String(q.upload_status)} // ensure string
                            onChange={(e) =>
                              handleChangeQAStatus(q.upload_id, q.upload_status)
                            }
                          >
                            <option value="1">Approved</option>
                            <option value="0">Rejected</option>
                          </select>
                        </td> */}
                        <td>
                          <img
                            src={viewIcon}
                            alt="View Q&A"
                            title="View Question & Answer"
                            className="icon-image"
                            style={{ cursor: "pointer", width: "18px" }}
                            onClick={() => {
                              setShowViewQAModal(true);
                              setViewQuestion(q.question);
                              setViewAnswer(q.answer);
                            }}
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {showViewQAModal && (
          <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
            <div className="modal-history modal-dialog-centered history-model">
              <div className="modal-content w-50 position-relative">
                {/* ❌ CLOSE BUTTON */}
                <button
                  type="button"
                  className="modal-close-btn position-absolute top-0 end-0 mt-2 me-2"
                  onClick={() => {
                    setShowViewQAModal(false);
                    setViewQuestion("");
                    setViewAnswer("");
                  }}
                >
                  <img
                    src={crossIcon}
                    className="icon-image cross-i"
                    alt="Close"
                  />
                </button>

                <p className="fw-bold mt-3 mb-3 text-center refresh-prompts">
                  Question & Answer
                </p>

                <div className="p-3">
                  {/* QUESTION */}
                  <label className="fw-bold mb-1">Question</label>
                  <div
                    style={{
                      maxHeight: "120px",
                      overflowY: "auto",
                      whiteSpace: "pre-wrap",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      padding: "10px",
                      backgroundColor: "#fafafa",
                      marginBottom: "15px",
                      fontSize: "14px",
                    }}
                  >
                    {viewQuestion || (
                      <span className="text-center refresh-prompts">No question available.</span>
                    )}
                  </div>

                  {/* ANSWER */}
                  <label className="fw-bold mb-1">Answer</label>
                  <div
                    style={{
                      maxHeight: "150px",
                      overflowY: "auto",
                      whiteSpace: "pre-wrap",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      padding: "10px",
                      backgroundColor: "#fafafa",
                      fontSize: "14px",
                    }}
                  >
                    {viewAnswer || (
                      <span className="text-center refresh-prompts">No answer available.</span>
                    )}
                  </div>
                </div>

                {/* FOOTER */}
                <div className="modal-footer justify-content-center">
                  <button
                    type="button"
                    className="px-5 rounded custom-btn border-none py-2 fw-bold history-btn"
                    onClick={() => {
                      setShowViewQAModal(false);
                      setViewQuestion("");
                      setViewAnswer("");
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Summary Section */}
        <div className="col-lg-4">
          <div className="card profile p-4 shadow-sm">
            <h5 className="fw-semibold  mb-4 ak-text-md">Summary</h5>
            <div className="d-flex justify-content-center align-items-center mb-4 position-relative">
              <svg
                width="140"
                height="140"
                viewBox="0 0 36 36"
                className="circular-chart"
              >
                <path
                  className="circle-bg"
                  d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                  fill="none"
                  stroke="#eee"
                  strokeWidth="2"
                />
                <path
                  className="circle"
                  strokeDasharray={`${summary.completion}, 100`}
                  stroke={summary.isLimitExceeded ? "#dc3545" : "#3e3e3e"}
                  d="M18 2.0845
                      a 15.9155 15.9155 0 0 1 0 31.831
                      a 15.9155 15.9155 0 0 1 0 -31.831"
                  fill="none"
                  strokeWidth="2"
                />
              </svg>
              <div className="position-absolute text-center">
                <div className=" ak-text-md">
                  {summary.isLimitExceeded ? "Limit Exceeded" : "Used"}
                </div>
                <div className="fw-bold fs-2">{summary.completion}%</div>
              </div>
            </div>
            <div className="row text-center mb-4">
              <div className="col">
                <div className=" ak-text-md fw-semibold">Total Q&A</div>
                <div className=" fw-semibold">
                  {/* {summary.totalCharacters.toLocaleString()} */}
                  {summary.totalQA}
                </div>
              </div>
              <div className="col">
                <div className="ak-text-md fw-semibold">Approved</div>
                <div className="fw-semibold text-success">
                  {summary.activeQA}
                </div>
              </div>
              <div className="col">
                <div className="ak-text-md fw-semibold text-danger">
                  Rejected
                </div>
                <div className="fw-semibold ">{summary.inactiveQA}</div>
              </div>
            </div>

            <div className="row text-center mb-4">
              <div className="col">
                <div className="ak-text-md fw-semibold">Characters</div>
                <div className="fw-semibold">
                  {summary.totalCharacters?.toLocaleString()}
                </div>
              </div>
              <div className="col">
                <div className="ak-text-md fw-semibold">Words</div>
                <div className="fw-semibold">
                  {summary.totalWords?.toLocaleString()}
                </div>
              </div>

              <div className="col">
                <div className=" ak-text-md fw-semibold">Limits</div>
                <div className=" fw-semibold">
                  {summary.limit?.toLocaleString()}
                </div>
              </div>
            </div>

            {summary.types &&
              Object.entries(summary.types).map(([type, data]) => {
                const percent = summary.totalQA
                  ? Math.round((data.count / summary.totalQA) * 100)
                  : 0;

                return (
                  <div key={type} className="mb-3">
                    <div className="d-flex justify-content-between ak-text-md fw-semibold">
                      <span className="refresh-prompts">
                        {type} ({data.count})
                      </span>
                      <span>{percent}%</span>
                    </div>

                    <div className="small text-secondary mb-1">
                      {data.words.toLocaleString()} words ·{" "}
                      {data.chars.toLocaleString()} characters
                    </div>

                    <div className="progress-track">
                      <div
                        className={`progress-fill ${
                          type === "Rejected" ? "danger" : "normal"
                        }`}
                        role="progressbar"
                        style={{ width: `${percent}%` }}
                      />
                    </div>
                  </div>
                );
              })}

            {!summary.isLimitExceeded && summary.completion >= 80 && (
              <div className=" text-center small mb-2">
                Almost there! You’re close to the training limit.
              </div>
            )}

            {summary.completion === 100 && !summary.isLimitExceeded && (
              <div className="text-success text-center small mb-2">
                Training data limit reached 🎉
              </div>
            )}

            {summary.isLimitExceeded && (
              <div className="alert alert-warning py-2 mb-3 text-center">
                ⚠️ Character limit exceeded by{" "}
                <strong>{summary.excessChars.toLocaleString()}</strong>{" "}
                characters.
                <div className="small mt-1">
                  New uploads are allowed but won’t improve training quality.
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainingQA;
